import React, { Component } from 'react';
import { getFanstepIcon, isEmpty } from '../../../../Common/Common';

export default class VAmount extends Component {
	constructor(props) {
		super(props);

		let vamount = 'L';
		this.steps = 2;
		if (!isEmpty(this.props.point_info)) {
			vamount = this.props.point_info.vamount;
		}
		let icon = getFanstepIcon(this.steps, vamount)

		this.state = {
			vamount: vamount,
			icon: icon
		}
	}

	handleChangeVAmount = () => {
		let vamount = this.state.vamount;

		if (vamount == 'L') {
			if (this.props.point_info.vamount_cap.H) vamount = 'H';
			else if (this.props.point_info.vamount_cap.A) vamount = 'A';
		} else if (vamount == 'H') {
			if (this.props.point_info.vamount_cap.A) vamount = 'A';
			else if (this.props.point_info.vamount_cap.L) vamount = 'L';
		} else if (vamount == 'A') {
			if (this.props.point_info.vamount_cap.L) vamount = 'L';
			else if (this.props.point_info.vamount_cap.H) vamount = 'H';
		}

		this.setState({
			vamount: vamount,
			icon: getFanstepIcon(this.steps, vamount)
		})

		this.props.handleChangeVAmount(vamount);
	}

	render() {
		return (
			<div id='vamount' style={this.props.style} onClick={this.handleChangeVAmount}>
				<div>
					<img src={this.state.icon} style={{ width: 40 }} />
				</div>
				<div>
					<span> {this.props.receiver.getString('vamount')} </span>
				</div>
			</div>
		)
	}
}